(() => {
  if (customElements.get('homepage-2026-use-cases')) return;

  class Homepage2026UseCases extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.nextButton = this.querySelector('.swiper-button-next');
      this.prevButton = this.querySelector('.swiper-button-prev');
      this.paginationEl = this.querySelector('.swiper-pagination');
      this.swiper = null;
    }

    connectedCallback() {
      if (this.swiper) return;
      if (typeof window.Swiper === 'undefined' || !this.swiperEl) return;

      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        pagination: {
          el: this.paginationEl,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1100: {
            slidesPerView: 3.1,
            spaceBetween: 24,
          },
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('homepage-2026-use-cases', Homepage2026UseCases);
})();
